<h2 mat-dialog-title class="dialog-header">
  <span>CV — {{ data.prenom }} {{ data.nom }}</span>
  <button mat-icon-button (click)="close()" matTooltip="Fermer">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<div class="metadata-bar" *ngIf="metadata">
  <span class="file-name">
    <mat-icon class="inline-icon">picture_as_pdf</mat-icon>
    {{ metadata.fileName }}
  </span>
  <span class="file-size">{{ (metadata.fileSizeBytes / 1024 / 1024) | number:'1.1-2' }} Mo</span>
  <span class="file-updated">Mis à jour le {{ metadata.updatedAt | date:'dd/MM/yyyy HH:mm' }}</span>
</div>

<mat-dialog-content class="viewer-content">

  <div class="state-row" *ngIf="loading">
    <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
    <span>Chargement du CV...</span>
  </div>

  <div class="state-row error-row" *ngIf="!loading && loadError">
    <mat-icon>error_outline</mat-icon>
    <span>Impossible d'afficher le CV. Vous pouvez essayer de le télécharger directement.</span>
  </div>

  <iframe
    *ngIf="!loading && !loadError && pdfSafeUrl"
    [src]="pdfSafeUrl"
    class="pdf-frame"
    title="Aperçu du CV">
  </iframe>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="download()">
    <mat-icon>file_download</mat-icon>
    Télécharger
  </button>
  <button mat-button (click)="close()">Fermer</button>
</mat-dialog-actions>
